/**
 * @generated SignedSource<<4b8c00a783b0091cea50f200ff50eb20>>
 * @relayHash 1c72061a9ff8d7b4a93f1d0481cc5da8
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-nft/539.0.0-2025-12-09T17:08:24.503Z/NftProfileImportCollectionViewNftTileSubscription

import { ConcreteRequest } from 'relay-runtime';
export type NftProfileImportCollectionViewNftTileSubscription$variables = {
  id: string;
};
export type NftProfileImportCollectionViewNftTileSubscription$data = {
  readonly nftItemDraftUpdate: {
    readonly nftItemDraft: {
      readonly serviceId: string | null;
    } | null;
  } | null;
};
export type NftProfileImportCollectionViewNftTileSubscription = {
  response: NftProfileImportCollectionViewNftTileSubscription$data;
  variables: NftProfileImportCollectionViewNftTileSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "nftItemId",
        "variableName": "id"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NftProfileImportCollectionViewNftTileSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "NftItemDraftUpdateSubscriptionPayload",
        "kind": "LinkedField",
        "name": "nftItemDraftUpdate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NftItemDraft",
            "kind": "LinkedField",
            "name": "nftItemDraft",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Subscriptions",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NftProfileImportCollectionViewNftTileSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "NftItemDraftUpdateSubscriptionPayload",
        "kind": "LinkedField",
        "name": "nftItemDraftUpdate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NftItemDraft",
            "kind": "LinkedField",
            "name": "nftItemDraft",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-nft/539.0.0-2025-12-09T17:08:24.503Z/NftProfileImportCollectionViewNftTileSubscription",
    "metadata": {},
    "name": "NftProfileImportCollectionViewNftTileSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "9451c470cd2cb12ca6aefa9efd4ca1bc";

export default node;
